import { cn } from "@rarible_int/anaconda_ui_components"
import { useEffect, useRef, useState } from "react"

interface Props {
  value: number
  displayValue: string
  className?: string
}

const HIGHLIGHT_DURATION = 300

/**
 * Highlight update only if displayValue values is changed
 *
 * Display value is used instead of number value to understand if visual representation for users is changed.
 * Number value is used to understnad if change trand is positive or negative.
 */
export function UpdateHighlighter({ value, displayValue, className }: Props) {
  const [highlightClassName, setHighlightClassName] = useState("")
  const prevValueRef = useRef(value)
  const prevDisplayValueRef = useRef(displayValue)

  useEffect(() => {
    if (displayValue === prevDisplayValueRef.current) return

    setHighlightClassName(
      value > prevValueRef.current
        ? "bg-success/30 text-success"
        : "bg-destructive/30 text-destructive",
    )

    const timer = setTimeout(
      () => setHighlightClassName(""),
      HIGHLIGHT_DURATION,
    )

    prevValueRef.current = value
    prevDisplayValueRef.current = displayValue

    return () => clearTimeout(timer)
  }, [displayValue, value])

  return (
    <span
      className={cn("transition ease-linear", highlightClassName, className)}
    >
      {displayValue}
    </span>
  )
}
